module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component component-backoffice-client-custom-fields-configuration"
  }, _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    }), _vm._l((elem), function(val, inx) {
      return _c('div', {
        staticClass: "column"
      }, [(inx !== 'validation' && inx !== 'default') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        attrs: {
          "type": "text",
          "placeholder": inx
        },
        domProps: {
          "value": (_vm.value[index][inx])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.value[index], inx, $event.target.value)
          }
        }
      }) : (inx !== 'default') ? _c('ValidationConfig', {
        attrs: {
          "validation-key": "validation"
        },
        model: {
          value: (_vm.value[index]),
          callback: function($$v) {
            _vm.$set(_vm.value, index, $$v)
          },
          expression: "value[index]"
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5000b781!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/ClientCustomFieldsConfiguration.vue
// module id = 2486
// module chunks = 1